import React, { useState, useEffect } from 'react';
import { Alert, Col, Form, Row } from 'react-bootstrap';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { faKey, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AuthSimpleLayout from 'layouts/authentication';
import Button from '../../components/base/Button';
import { login } from '../../shared/stored/Users/slice';
import { REDIRECT_URL } from '../../shared/constant';
import { RootState } from '../../shared/stored/store';

const SignIn = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    rememberMe: false
  });
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isFetching, error: authError, form: formErrors } = useSelector((state: RootState) => state.user);
  
  const redirectUrl = searchParams.get(REDIRECT_URL) || '/';

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.username || !formData.password) {
      return;
    }

    dispatch(login({
      username: formData.username,
      password: formData.password,
      callback: (success: boolean) => {
        if (success) {
          navigate(redirectUrl);
        }
      }
    }));
  };

  return (
    <AuthSimpleLayout>
      <>
        <div className="text-center mb-7">
          <h3 className="text-body-highlight">Sign In</h3>
        </div>
        <div className="position-relative">
          <hr className="bg-body-secondary mt-5 mb-4" />
          <div className="divider-content-center">Get access to your account</div>
        </div>
        
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3 text-start">
            <Form.Label htmlFor="username">Email address or Username</Form.Label>
            <div className="form-icon-container">
              <Form.Control 
                id="username"
                name="username"
                type="text" 
                className="form-icon-input" 
                placeholder="name@example.com or username"
                value={formData.username}
                onChange={handleInputChange}
                required
              />
              <FontAwesomeIcon icon={faUser} className="text-body fs-9 form-icon" />
            </div>
          </Form.Group>
          <Form.Group className="mb-3 text-start">
            <Form.Label htmlFor="password">Password</Form.Label>
            <div className="form-icon-container">
              <Form.Control 
                id="password"
                name="password"
                type="password" 
                className="form-icon-input" 
                placeholder="Password"
                value={formData.password}
                onChange={handleInputChange}
                required
              />
              <FontAwesomeIcon icon={faKey} className="text-body fs-9 form-icon" />
            </div>
          </Form.Group>
          <Row className="flex-between-center mb-7">
            <Col xs="auto">
              <Form.Check type="checkbox" className="mb-0">
                <Form.Check.Input 
                  type="checkbox" 
                  name="rememberMe" 
                  id="rememberMe" 
                  checked={formData.rememberMe}
                  onChange={handleInputChange}
                />
                <Form.Check.Label htmlFor="rememberMe" className="mb-0">
                  Remember me
                </Form.Check.Label>
              </Form.Check>
            </Col>
            <Col xs="auto">
              <Link to="/forgot-password" className="fs-9 fw-semibold">
                Forgot Password?
              </Link>
            </Col>
          </Row>
          <Button 
            variant="primary" 
            className="w-100 mb-3"
            type="submit"
            disabled={isFetching}
          >
            {isFetching ? 'Signing In...' : 'Sign In'}
          </Button>
        </Form>
        
        {/* Hide sign up link as per requirements */}
        {/* <div className="text-center">
          <Link to="/sign-up" className="fs-9 fw-bold">
            Create an account
          </Link>
        </div> */}
      </>
    </AuthSimpleLayout>
  );
};

export default SignIn;
